<div class="order-preparation-form flex-column gap-10">

  @if (headerPrompt) {
  <label>{{ headerPrompt | transloco }}</label>
  }
  <mat-form-field class="destination-field"
                  [appearance]="appearance">
    <mat-label>{{ preparationSettings?.tableNamePrefix ?? 'Table ' }}</mat-label>
    <mat-icon matPrefix
              color="primary">room_service</mat-icon>
    <input matInput
           type="number"
           [formControl]="destinationFormControl"
           [placeholder]="preparationSettings?.tableNamePrefix ?? 'Table'"
           min="1"
           [max]="this.preparationSettings?.tableServiceMaxTables ?? 99">
    <!-- <mat-hint align="start">{{ 'COMMAND.ORDER_PREPARATION.TABLE_NUMBER' | transloco }}</mat-hint> -->
    @if (preparationSettings?.tableServiceMaxTables) {
    <mat-hint align="end">de 1 à {{preparationSettings.tableServiceMaxTables}}</mat-hint>
    }
    @if (destinationFormControl.touched && destinationFormControl.hasError('required')) {
    <mat-error>
      {{ 'COMMON.ERRORS.FIELD_REQUIRED_FORMAT' | transloco : { field: 'COMMAND.ORDER_PREPARATION.TABLE_NUMBER' | transloco } }}
    </mat-error>
    }
    @if (destinationFormControl.touched && (destinationFormControl.hasError('min') || destinationFormControl.hasError('max'))) {
    <mat-error>
      {{ 'COMMON.ERRORS.FIELD_RANGE_FORMAT' | transloco : { field: 'COMMAND.ORDER_PREPARATION.TABLE_NUMBER' | transloco, minValue: 1, maxValue: this.preparationSettings?.tableServiceMaxTables ?? 99 } }}
    </mat-error>
    }
  </mat-form-field>

</div>
